import { getNodeValue } from '../utils/get-node-value.helper';
import { calculateMaxHeatProductionCapacity } from '../../energy/heating-energy.helpers';

export function getMaxHeatProductionCapacity(
  args: any[],
  math: any,
  scope: any,
): number {
  const annualHeatRequirement = getNodeValue(args[0], math, scope);
  const location = getNodeValue(args[1], math, scope);
  return calculateMaxHeatProductionCapacity(annualHeatRequirement, {
    location,
  });
}

getMaxHeatProductionCapacity.rawArgs = true;
